export default {
  LOAD_SESSION_OVERVIEW_PAGE_START: 'LoadGeneralCompetencyEventSessionOverviewPageStart',
  LOAD_SESSION_OVERVIEW_PAGE_END: 'LoadGeneralCompetencyEventSessionOverviewPageEnd',
  TOGGLE_SESSION_OVERVIEW_CONFIRM_DIALOG: 'ToggleGeneralCompetencyEventSessionOverviewConfirmDialog',
  LOAD_SESSION_PARTICIPANTS_START: 'LoadGeneralCompetencyEventSessionParticipantsStart',
  LOAD_SESSION_PARTICIPANTS_END: 'LoadGeneralCompetencyEventSessionParticipantsEnd',
  SET_PARTICIPANTS_KEYWORD: 'SetGeneralCompetencyEventSessionParticipantsKeyword',
  SORT_PARTICIPANTS: 'SortGeneralCompetencyEventSessionParticipants',
  TOGGLE_ADD_PARTICIPANT_DIALOG: 'ToggleGeneralCompetencyEventSessionAddParticipantDialog',
  ADD_PARTICIPANT_END: 'AddGeneralCompetencyEventSessionParticipantEnd',
  LOAD_AVAILABLE_STUDENTS_START: 'LoadGeneralCompetencyEventSessionAvailableStudentsStart',
  LOAD_AVAILABLE_STUDENTS_END: 'LoadGeneralCompetencyEventSessionAvailableStudentsEnd',
  TOGGLE_REMOVE_PARTICIPANT_DIALOG: 'ToggleGeneralCompetencyEventSessionRemoveParticipantDialog',
  CLEANUP_SESSION_OVERVIEW: 'CleanupGeneralCompetencyEventSessionOverview'
};
